import React, { Component } from 'react';
import actions from '../actions';
import sharedActions from '../../shared/actions';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import _ from '../../shared/utils/ObjectUtils';
import EntityInterfacesForm from "../components/EntityInterfacesForm";
import entityActions from "../../entities/actions";
import interfaceActions from "../../interfaces/actions";
import terminalActions from "../../terminals/actions";

class EntityInterfacesFormContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewMode: !_.isNilOrEmpty(props.entityInterfaceId),
            editMode: false,
            createMode: _.isNilOrEmpty(props.entityInterfaceId),
            alert: {
                show: false
            },
            entityInterfaceFormData: {
                entity: {
                    value: undefined,
                    error: undefined,
                    data: [],
                    required: true
                },
                name: {
                    value: undefined,
                    error: undefined,
                    required: false
                }
            }
        }
    }

    componentDidMount() {
        const {
            entityId,
            terminalId,
            interfaceId,
            entityInterfaceId,
            getCategoryList,
            getEntityList,
            getEntityInterfaceData,
            getTerminalData,
            getEntityData,
            getInterfaceData
        } = this.props;

        if (entityInterfaceId) {
            getEntityInterfaceData(entityId, entityInterfaceId);
        }

        if(terminalId) {
            getTerminalData(terminalId);
        }

        if(interfaceId) {
            getInterfaceData(interfaceId);
        }

        if(entityId) {
            getEntityData(entityId);
        }

        getEntityList();
        getCategoryList();
    };

    componentWillUnmount() {
        this.props.updateCustomTitle();
        this.props.updateCustomBreadcrumbs();
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            loadingDeleteRequest : oldLoadingDeleteRequest,
            loadingCreateRequest : oldLoadingCreateRequest,
            loadingEditRequest : oldLoadingEditRequest,
            loadingEntityInterface: oldLoadingEntityInterface,
            entityId
        } = prevProps;
        const {
            loadingDeleteRequest : nextLoadingDeleteRequest,
            loadingCreateRequest : nextLoadingCreateRequest,
            loadingEditRequest : nextLoadingEditRequest,
            loadingEntityInterface: nextLoadingEntityInterface,
            loadingTerminal: nextLoadingTerminal,
            loadingEntity: nextLoadingEntity,
            loadingInterface: nextLoadingInterface,
            entityInterfaceWasDeleted,
            entityInterfaceWasCreated,
            entityInterfaceWasEdited,
            entityInterfaceData,
            entity,
            terminal,
            interfaceData,
            error
        } = this.props;

        //Handle Error, Edit and Create
        if (oldLoadingDeleteRequest && !nextLoadingDeleteRequest) {
            if (entityInterfaceWasDeleted) {
                this.handleEntityInterfaceDeleteSuccess()
            } else {
                this.handleEntityInterfaceDeleteError(error)
            }
        } else if (oldLoadingCreateRequest && !nextLoadingCreateRequest){
            if (entityInterfaceWasCreated) {
                this.handleEntityInterfaceCreateSuccess()
            } else {
                this.handleEntityInterfaceCreateError(error)
            }
        } else if (oldLoadingEditRequest && !nextLoadingEditRequest){
            if (entityInterfaceWasEdited) {
                this.handleEntityInterfaceEditSuccess()
            } else {
                this.handleEntityInterfaceEditError(error)
            }
        } else if (oldLoadingEntityInterface && !nextLoadingEntityInterface) {
            this.handleEntityInterfaceLoadingCompleted(entityInterfaceData);
        }
        if(!nextLoadingEntityInterface && !nextLoadingTerminal && !nextLoadingInterface && !nextLoadingEntity
            && (( !_.isNilOrEmpty(terminal) && !_.isNilOrEmpty(interfaceData) ) || !_.isNilOrEmpty(entity) ) ) {
            this.handleEntityInterfaceAndTerminalOrEntityLoadingCompleted(entityInterfaceData, terminal, interfaceData, entity, entityId);
        }
    };

    handleEntityInterfaceLoadingCompleted = (entityInterfaceData) => {
        this.setState({
            entityInterfaceFormData: {
                ...this.state.entityInterfaceFormData,
                ...Object.entries(entityInterfaceData).reduce(
                    (acc, keyValuePair) => ({
                        ...acc,
                        [keyValuePair[0]]: {
                            ...acc[keyValuePair[0]],
                            ...this.state.entityInterfaceFormData[keyValuePair[0]],
                            value: keyValuePair[1]
                        }
                    }), {})
            }
        })
    };

    handleEntityInterfaceAndTerminalOrEntityLoadingCompleted = (entityInterfaceData, terminal, interfaceData, entity) => {
        const {
            updateCustomTitle,
            updateCustomBreadcrumbs,
            entityId
        } = this.props;

        const entityInterfaceTitle = entityInterfaceData.name ? entityInterfaceData.name : I18n.t('routes.entityInterfacesCreate');

        updateCustomTitle(entityInterfaceTitle);

        if (entityId) {
            updateCustomBreadcrumbs([{
                link: "/entities",
                name: I18n.t('routes.entities')
            }, {
                link: "/entities/" + entity.id,
                name: entity.name
            }, {
                link: "/entities/" + entity.id + "/entityInterfaces/" + entityInterfaceData.id,
                name: entityInterfaceData.name
            }]);
        } else {
            updateCustomBreadcrumbs([{
                link: "/terminals",
                name: I18n.t('routes.terminals')
            }, {
                link: "/terminals/" + terminal.id,
                name: terminal.name
            }, {
                link: "/terminals/" + terminal.id + "/interfaces/" + interfaceData.id,
                name: interfaceData.name
            }, {
                link: "/terminals/" + terminal.id + "/interfaces/" + interfaceData.id + "/entityInterfaces/",
                name: entityInterfaceTitle
            }]);
        }

    };

    handleFieldChange = (id, value) => {
        this.setState({
            entityInterfaceFormData: {
                ...this.state.entityInterfaceFormData,
                [id]: {
                    ...this.state.entityInterfaceFormData[id],
                    value: value
                }
            }
        }, () => {
            if(_.has(this.state.entityInterfaceFormData[id], 'required')) {
                this.validateField(id);
            }
        })
    };

    validateField = (key) => {
        let { entityInterfaceFormData } = this.state;
        let error = null;
        switch (key) {
            default:
                if (!_.isNilOrEmpty(entityInterfaceFormData[key].error) &&
                    entityInterfaceFormData[key].required &&
                    !_.isNilOrEmpty(entityInterfaceFormData[key].value) ) {
                    error = undefined;
                } else if(entityInterfaceFormData[key].required &&
                    _.isNilOrEmpty(entityInterfaceFormData[key].value)) {
                    error = I18n.t('forms.errors.emptyRequiredField')
                }
                break;
        }
        if (error !== entityInterfaceFormData[key].error) {
            entityInterfaceFormData[key].error = error;
            this.setState({
                entityInterfaceFormData,
            });
        }
    };

    handleOnFieldBlur = (key) => {
        this.validateField(key)
    };

    handleSubmitClick = () => {
        let { editMode, entityInterfaceFormData } = this.state;
        const {
            entityId,
            entityInterfaceId,
            interfaceId,
            editEntityInterface,
            createEntityInterface
        } = this.props;

        let formHasErrors = false;

        _.forOwn(entityInterfaceFormData, field => {
            if((field.required && _.isNilOrEmpty(field.value))) {
                field.error = I18n.t('forms.errors.emptyRequiredField');
                formHasErrors = true;
            } else if(!_.isNilOrEmpty(field.error)) {
                formHasErrors = true;
            } else {
                field.error = undefined;
            }
        });

        if(!formHasErrors) {
            const formDataToBeSubmitted = Object.entries(entityInterfaceFormData).reduce((acc, keyValuePair) => {
                return {
                    ...acc,
                    [keyValuePair[0]]: keyValuePair[1].value,
                }
            }, { });

            const entityInterfaceName = formDataToBeSubmitted.name;
            if (editMode) {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('entityInterfaces.alerts.edit.title'),
                        html: I18n.t('entityInterfaces.alerts.edit.text', {entityInterface: entityInterfaceName}),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            editEntityInterface(entityId, entityInterfaceId, formDataToBeSubmitted)
                        }
                    }
                })
            } else {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('entityInterfaces.alerts.create.title'),
                        html: I18n.t('entityInterfaces.alerts.create.text', {entityInterface: entityInterfaceName}),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            createEntityInterface(interfaceId, formDataToBeSubmitted)
                        }
                    }
                })
            }
        } else {
            this.setState({
                entityInterfaceFormData,
            });
        }
    };

    handleEditClick =() => {
        const { editMode } = this.state;
        const { entityInterfaceData } = this.props;

        if (editMode) {
            this.setState({
                ...this.state,
                editMode: false,
                viewMode: true,
                entityInterfaceFormData:
                    Object.entries(this.state.entityInterfaceFormData).reduce((acc, keyValuePair) => {
                        return {
                            ...acc,
                            [keyValuePair[0]]: {
                                ...this.state.entityInterfaceFormData[keyValuePair[0]],
                                value: entityInterfaceData[keyValuePair[0]] ? entityInterfaceData[keyValuePair[0]] : undefined,
                                error: undefined,
                            }
                        }
                    }, {})
            })
        } else {
            this.setState({
                viewMode: false,
                editMode: true
            })
        }
    };

    hideAlert = () => {
        this.setState({
            alert: {
                show: false
            }
        })
    };

    handleBackClick = () => {
        this.props.resetEntityInterfaceForm();
        this.hideAlert();

        const { entityId, terminalId, interfaceId } = this.props;

        if (entityId) {
            this.props.history.push('/entities/' + entityId);
        } else {
            this.props.history.push('/terminals/' + terminalId + '/interfaces/' + interfaceId);
        }
    };

    handleDeleteClick = () => {
        const { entityId, entityInterfaceId, deleteEntityInterface } = this.props;
        const {
            entityInterfaceFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: "warning",
                title: I18n.t('entityInterfaces.alerts.delete.title'),
                html: I18n.t('entityInterfaces.alerts.delete.text', {entityInterface: name}),
                confirmButtonText: I18n.t('forms.delete'),
                cancelButtonText: I18n.t('forms.cancel'),
                onCancel: this.hideAlert,
                onConfirm: () => {
                    deleteEntityInterface(entityId, entityInterfaceId)
                }
            }
        })
    };

    handleEntityInterfaceDeleteSuccess = () => {
        const {
            entityInterfaceFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('entityInterfaces.alerts.delete.success.title'),
                html: I18n.t('entityInterfaces.alerts.delete.success.text', {entityInterface: name}),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleEntityInterfaceDeleteError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('entityInterfaces.alerts.delete.error.title'),
                html: I18n.t('entityInterfaces.alerts.delete.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleEntityInterfaceCreateSuccess = () => {
        const {
            entityInterfaceFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('entityInterfaces.alerts.create.success.title'),
                html: I18n.t('entityInterfaces.alerts.create.success.text', {entityInterface: name}),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleEntityInterfaceCreateError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('entityInterfaces.alerts.create.error.title'),
                html: I18n.t('entityInterfaces.alerts.create.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleEntityInterfaceEditSuccess = () => {
        const {
            entityInterfaceFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('entityInterfaces.alerts.edit.success.title'),
                html: I18n.t('entityInterfaces.alerts.edit.success.text', {entityInterface: name}),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleEntityInterfaceEditError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('interfaces.alerts.edit.error.title'),
                html: I18n.t('interfaces.alerts.edit.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    render() {
        const { 
            createMode, 
            editMode, 
            viewMode,
            entityInterfaceFormData,
            alert 
        } = this.state;

        const { 
            loadingDeleteRequest, 
            loadingCreateRequest, 
            loadingEditRequest, 
            categoryList,
            entityList
        } = this.props;

        return <EntityInterfacesForm
            editMode={editMode}
            createMode={createMode}
            viewMode={viewMode}
            alert={{
                ...alert,
                loading: loadingDeleteRequest || loadingCreateRequest || loadingEditRequest
            }}

            entityInterfaceFormData={entityInterfaceFormData}

            entityList={entityList}
            categoryList={categoryList}

            handleFieldChange={this.handleFieldChange}
            handleOnFieldBlur={this.handleOnFieldBlur}
            handleSubmitClick={this.handleSubmitClick}

            handleEditClick={this.handleEditClick}
            handleDeleteClick={this.handleDeleteClick}
            handleBackClick={this.handleBackClick}
        />
    }
}

const mapStateToProps = ({
    entityInterfacesReducer,
    entitiesReducer,
    terminalsReducer,
    interfacesReducer
}) => {
    return {
        entityInterfaceData: entityInterfacesReducer.entityInterfaceData,
        loadingEntityInterface: entityInterfacesReducer.loading,
        error: entityInterfacesReducer.error,

        loadingDeleteRequest: entityInterfacesReducer.loadingDeleteRequest,
        entityInterfaceWasDeleted: entityInterfacesReducer.entityInterfaceWasDeleted,

        loadingCreateRequest: entityInterfacesReducer.loadingCreateRequest,
        entityInterfaceWasCreated: entityInterfacesReducer.entityInterfaceWasCreated,

        loadingEditRequest: entityInterfacesReducer.loadingEditRequest,
        entityInterfaceWasEdited: entityInterfacesReducer.entityInterfaceWasEdited,

        entityList: entitiesReducer.entityList,

        interfaceData: interfacesReducer.interfaceData,
        loadingInterface: interfacesReducer.loadingInterface,

        entity: entitiesReducer.entityData,
        loadingEntity: entitiesReducer.loadingEntity,

        terminal: terminalsReducer.terminalData,
        loadingTerminal: terminalsReducer.loadingTerminal
    };
};

const mapDispatchToProps = {
    getEntityInterfaceData: actions.getEntityInterfaceData,
    createEntityInterface: actions.createEntityInterface,
    editEntityInterface: actions.editEntityInterface,
    deleteEntityInterface: actions.deleteEntityInterface,
    resetEntityInterfaceForm: actions.resetEntityInterfaceForm,
    getCategoryList: interfaceActions.getCategoryList,
    getEntityList: entityActions.getEntityList,

    getEntityData: entityActions.getEntityData,
    getInterfaceData: interfaceActions.getInterfaceData,
    getTerminalData: terminalActions.getTerminalData,

    updateCustomTitle: sharedActions.updateCustomTitle,
    updateCustomBreadcrumbs: sharedActions.updateCustomBreadcrumbs
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EntityInterfacesFormContainer);
